module.exports = __webpack_public_path__ + "img/Macau.602e116b.jpg";